import { ReactNode } from 'react';

import { Column } from './Column';
import { ActionIcon } from './components/icons/ActionIcon';
import { ColumnProps, RowState } from './types';

type ActionColumnProps<T> = Partial<ColumnProps<T>> & {
  action?: (row: T, state: RowState<T>) => ReactNode;
};
export const makeActionsColumn = <T,>({
  action,
  id = 'actions',
  width = 56,
  ...props
}: ActionColumnProps<T>) => {
  return (
    <Column
      id={id}
      width={width}
      renderCell={
        action
          ? (row, state) => {
              const content = action(row, state);
              if (content) {
                return <ActionIcon>{content}</ActionIcon>;
              }
              return null;
            }
          : undefined
      }
      floating
      stopClickPropagation
      {...props}
    />
  );
};
